export enum RolloutPlanStepId {
  PlanDetails = 'planDetails',
  TargetProductGroups = 'targetProductGroups',
  DistributionSettings = 'distributionSettings',
  summary = 'summary'
}

export const ROLLOUT_PLAN_STEP_CONFIG = [
  { id: RolloutPlanStepId.PlanDetails, label: 'Plan details' },
  { id: RolloutPlanStepId.TargetProductGroups, label: 'Target product groups' },
  {
    id: RolloutPlanStepId.DistributionSettings,
    label: 'Distribution settings'
  },
  { id: RolloutPlanStepId.summary, label: 'Summary' }
];
